import ToDoList from "./pages/toDoList/ToDoList";

function App(){
  return(
    <ToDoList/>
  );
   
}

export default App;   